<template>
  <div v-if="heurekav2.active" class="mb-1">
    <div class="form-check">
      <input id="dm_heurekav2_consent_checkbox" type="checkbox" class="form-check-input" :checked="heurekav2.checked" @change="updateValue">
      <label class="form-check-label" for="dm_heurekav2_consent_checkbox">
        {{ heurekav2.text }}
        <span v-if="heurekav2.showLink">
          <a :href="heurekav2.link" target="_blank" class="dm_heurekav2_consent_link">{{ heurekav2.linkName }}</a>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      heurekav2: state => state.dmHeurekaV2,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('dmHeurekaV2/SET', e.target.checked);
    }
  },
  mounted () {
    this.$store.commit('dmHeurekaV2/SET', this.heurekav2.defaultChecked);
  },
};
</script>

<style scoped>
  .dm_heurekav2_consent_link {
    text-decoration: underline;
  }
</style>
